import { memo, ReactFragment, useState } from "react";

import styled from "styled-components";

import Collapse from "@mui/material/Collapse";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";

import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";

// -----------------------------------------------------------------------------

const SidebarCategory = memo(function SidebarCategory({
  label,
  Icon,
  children,
}: SidebarCategoryProps): JSX.Element {
  const [open, toggleOpen] = useToggleValue(false);

  //
  return (
    <>
      <Button onClick={toggleOpen}>
        <ListItemIcon>
          <Icon />
        </ListItemIcon>
        <Label primary={label} />
        {open ? <ExpandLess /> : <ExpandMore />}
      </Button>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {children}
        </List>
      </Collapse>
    </>
  );
});

export default SidebarCategory;

// -----------------------------------------------------------------------------

function useToggleValue(defaultValue: boolean): [boolean, () => void] {
  const [open, setOpen] = useState(defaultValue);

  //
  function toggleOpen() {
    setOpen(toOppositeValue);
  }

  //
  return [open, toggleOpen];
}

function toOppositeValue(value: boolean): boolean {
  return !value;
}

// -----------------------------------------------------------------------------

const Button = styled(ListItemButton)`
  display: grid;
  grid-template-columns: auto 1fr auto;

  .MuiListItemIcon-root {
    min-width: 32px;
    width: 32px;
  }
`;

const Label = styled(ListItemText)`
  display: flex;

  & > span {
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

// -----------------------------------------------------------------------------

interface SidebarCategoryProps {
  label: string;
  Icon: Function;
  children: ReactFragment;
}
